import React, { useContext } from 'react';
import { IFrame as Iframe, TmoCard } from '@tmobile/tmo-bps-syncup-web-component-lib';

import config from '../../../configs/config';
import SyncUpProductContext from '../../../context/SyncUpProductContext';

const { iframeQueryToolWatchURL } = config.powerBiSettings;

function QueryToolMetrics() {
  const syncUpProductContext = useContext(SyncUpProductContext);
  const iframe = () => {
    switch (syncUpProductContext.syncUpAppName) {
      case 'TRACKER':
        return '';
      case 'KIDSWATCH':
        return iframeQueryToolWatchURL;
      case 'DRIVE':
        return '';
      default:
        return '';
    }
  };

  return (
    <TmoCard>
      <Iframe src={iframe()} width="100%" height="836px" />
    </TmoCard>
  );
}

export default QueryToolMetrics;
